import React, { Fragment } from "react";
import DashBoard from "./dashboard/DashBoard";
import Orders from "./order/Orders";
import ProductCatalog from "./productcatalog/ProductCatalog";
import ServiceCatalog from "./servicecatalog/ServiceCatalog";
import Service from "./service/Service";
import ProtectedRoutes from "../ProtectedRoutes";
import "./contentcontainer.scss";
import Returns from "./returns/Returns";
import ViewReturn from "./returns/ViewReturn";
import OrderDetails from "./orderdetals/OrderDetails";
import Profile from "./profile/Profile";
import DisputesDetails from "./disputesdetails/DisputesDetails";
import Shop from "./shop/Shop";
import Disputes from "./disputes/Disputes";
import Report from "./report/Report";
import Emails from "./emails/Emails";
import Coupons from "./coupons/Coupons";
import SendEmail from "./sendemail/SendEmail";
import ProductPage from "../../pages/vendor/productCard/ProductPage";
import Banners from "../../pages/vendor/banners/Banners";
import CreateBanner from "../../pages/vendor/banners/CreateBanner/CreateBanner";
import ViewBanner from "./banners/ViewBanner/ViewBanner";
import EditStore from "./editStore/EditStore";
import ChangePassword from "./changePassword/ChangePassword";
import UpdateBanner from "./banners/UpdateBanner/UpdateBanner";
import MenuItems from "./menu/MenuItems";
import AddMenu from "./menu/AddMenuItem";
import EditMenu from "./menu/EditMenuItem";
import ShopBanners from "./shop_banners/ShopBanners";
import CreateShopBanner from "./shop_banners/CreateBanner/CreateShopBanner";
import UpdateShopBanner from "./shop_banners/UpdateBanner/UpdateShopBanner";
import ViewShopBanner from "./shop_banners/ViewBanner/ViewShopBanner";
import Onboarding from "./onboarding/Onboarding";

const ContentContainer = (props) => {
  return (
    <Fragment>
      <div className="content-container-desktop">
        <ProtectedRoutes exact path="/vendor/" component={DashBoard} />
        <ProtectedRoutes
          exact
          path="/vendor/product/:id?/:state?"
          component={ProductPage}
        />
        <ProtectedRoutes exact path="/vendor/orders" component={Orders} />
        <ProtectedRoutes
          exact
          path="/vendor/service-catalog"
          component={ServiceCatalog}
        />
        <ProtectedRoutes
          exact
          path="/vendor/onboarding"
          component={Onboarding}
        />
        <ProtectedRoutes
          exact
          path="/vendor/product-catalog"
          component={ProductCatalog}
        />

        <ProtectedRoutes exact path="/vendor/menu" component={MenuItems} />

        <ProtectedRoutes
          exact
          path="/vendor/menu-item/add"
          component={AddMenu}
        />

        <ProtectedRoutes
          exact
          path="/vendor/menu-item/edit/:id"
          component={EditMenu}
        />

        <ProtectedRoutes
          exact
          path="/vendor/service/:id?/:state?"
          component={Service}
        />
        <ProtectedRoutes exact path="/vendor/returns" component={Returns} />
        <ProtectedRoutes
          exact
          path="/vendor/view-return/:id"
          component={ViewReturn}
        />
        <ProtectedRoutes
          exact
          path="/vendor/order-detail/:id"
          component={OrderDetails}
        />
        <ProtectedRoutes exact path="/vendor/profile" component={Profile} />
        <ProtectedRoutes
          exact
          path="/vendor/disputes-detail/:id"
          component={DisputesDetails}
        />
        <ProtectedRoutes exact path="/vendor/shop" component={Shop} />
        <ProtectedRoutes exact path="/vendor/disputes" component={Disputes} />

        <ProtectedRoutes
          exact
          path="/vendor/shop-banners"
          component={ShopBanners}
        />
        <ProtectedRoutes
          exact
          path="/vendor/shop-banner/create"
          component={CreateShopBanner}
        />
        <ProtectedRoutes
          exact
          path="/vendor/shop-banner/update/:id"
          component={UpdateShopBanner}
        />
        <ProtectedRoutes
          exact
          path="/vendor/view-shop-banner/:id"
          component={ViewShopBanner}
        />

        <ProtectedRoutes exact path="/vendor/banners" component={Banners} />
        <ProtectedRoutes
          exact
          path="/vendor/create-banner"
          component={CreateBanner}
        />
        <ProtectedRoutes
          exact
          path="/vendor/view-banner/:id"
          component={ViewBanner}
        />
        <ProtectedRoutes
          exact
          path="/vendor/update-banner/:id"
          component={UpdateBanner}
        />
        <ProtectedRoutes exact path="/vendor/reports" component={Report} />
        <ProtectedRoutes exact path="/vendor/emails" component={Emails} />
        <ProtectedRoutes
          exact
          path="/vendor/send-email"
          component={SendEmail}
        />
        <ProtectedRoutes exact path="/vendor/coupons" component={Coupons} />
        <ProtectedRoutes
          exact
          path="/vendor/edit-store"
          component={EditStore}
        />
        <ProtectedRoutes
          exact
          path="/vendor/change-password"
          component={ChangePassword}
        />
      </div>
    </Fragment>
  );
};

export default ContentContainer;
